// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"b1f727d9","261":"4e1e38eb","374":"c4342ef1","453":"253c9c94","481":"ada848fe","493":"6fbd02e4","567":"1da6f403","709":"5ec06fef","761":"501fbbcc","890":"e0d6652c","989":"3a834c0d"}[chunkId] + ".chunk.js";
};